// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.documents-panel {
  margin-top: 1.5rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
  border: 1px solid var(--border-color);
}

.documents-frame {
  width: 100%;
  height: 70vh;
  border: none;
  display: block;
  background: white;
}

.documents-download-text {
  margin-top: 24px;
}

.documents-download-text a {
  color: #c4b5fd;
}

.documents-download-text a:hover {
  color: #e5e7ff;
}


`, "",{"version":3,"sources":["webpack://./src/components/pages/Documents.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".documents-page {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n}\r\n\r\n.documents-panel {\r\n  margin-top: 1.5rem;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  box-shadow: var(--shadow-card);\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.documents-frame {\r\n  width: 100%;\r\n  height: 70vh;\r\n  border: none;\r\n  display: block;\r\n  background: white;\r\n}\r\n\r\n.documents-download-text {\r\n  margin-top: 24px;\r\n}\r\n\r\n.documents-download-text a {\r\n  color: #c4b5fd;\r\n}\r\n\r\n.documents-download-text a:hover {\r\n  color: #e5e7ff;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
